// Originally scaffolded by the Supabase integration; hand-maintained since.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// supabase-js coordinates auth-token access with the Web Locks API
// (navigator.locks). In Safari that lock can hang indefinitely, leaving
// getSession() unresolved → the app stuck on the auth spinner forever
// (ProtectedRoute waits on AuthContext.isLoading). Override with a
// pass-through lock so auth never blocks on Web Locks. Trade-off: no
// cross-tab refresh coordination, which is fine for this app.
const passthroughLock = async <R>(
  _name: string,
  _acquireTimeout: number,
  fn: () => Promise<R>,
): Promise<R> => fn();

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    lock: passthroughLock,
  }
});